module.exports = "//public.getcloudapp.com/packs/media/images/atlassian-fa36596922f281967f4d99392f76e91c.png";